import http, { url } from '../../http'

const API_URL = "preventive-measure-verification"

/** Ítem 4.2.2 — Verificación de las medidas de prevención y control (última versión de la matriz 4.2.1). */
class PreventiveMeasureVerificationAPI {

  // Medidas de la última matriz 4.2.1 + su verificación + matriz (id/versión) para anclar el informe.
  async measures(companyId) {
    const response = await http(`${API_URL}/company/${companyId}`, 'GET')
    return response || null
  }

  async upsert(payload) {
    return await http(`${API_URL}/upsert`, 'POST', payload)
  }

  // Informe de verificación branded firmable (anclado a la matriz).
  pdfUrl(matrixId) {
    return url(`${API_URL}/${matrixId}/pdf`)
  }

  async status(matrixId) {
    return await http(`${API_URL}/${matrixId}/status`, 'GET')
  }

  async sign(matrixId, payload) {
    return await http(`${API_URL}/${matrixId}/sign`, 'POST', payload)
  }
}

export default new PreventiveMeasureVerificationAPI()
